import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ARABIC, ENGLISH } from '../constants/Values';
@Injectable({
  providedIn: 'root'
})
export class LiveTranslateService {
  lang: { [key: string]: any } = {};
  allLang: { [key: string]: any } = {};
  currentLang: string = 'en';
  isReady = false;
  $isReady: BehaviorSubject<string> = new BehaviorSubject<string>('false');
  // func: () => void = () => null;

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) {
    this.initialize();
  }

  initialize() {
    this.loudLangValues([ENGLISH, ARABIC]);
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = this.translate.currentLang;
      this.getLangValues();
      // this.func();;
    });
  }

  getLangValues() {
    this.lang = this.allLang[this.translate.currentLang ?? 'en'];
  }

  loudLangValues(langs: string[]) {
    // Logger.debug('langs', langs);
    const lang = langs.pop();
    if (lang) {
      this.http.get(`assets/i18n/${lang}.json`, { responseType: 'text' })
        .subscribe(data => {
          if (data) {
            this.allLang[lang] = JSON.parse(data);
          }
          // Logger.debug('11111langs', langs);
          if (langs.length > 0) this.loudLangValues(langs);
          else {
            this.lang = this.allLang[this.translate.currentLang];
            this.getLangValues();
            this.isReady = true;
            this.$isReady.next('done');
          }
        });
    }
  }
}
